import { z } from "zod/v4";

export const AiGetOnsiteEditTitleRequestBodySchema = z.object({
  find: z.string(),
  replacements: z.string().array(),
  querySelectors: z.string(),
  version: z.string(),
});

export type AiGetOnsiteEditTitleRequestBodyType = z.infer<
  typeof AiGetOnsiteEditTitleRequestBodySchema
>;

export const AiGetOnsiteEditTitleChatCompletionResponseSchema = z.object({
  title: z.string(),
});
export type AiGetOnsiteEditTitleChatCompletionResponseType = z.infer<
  typeof AiGetOnsiteEditTitleChatCompletionResponseSchema
>;

export const AiGetOnsiteEditTitleResponseBodySchema =
  AiGetOnsiteEditTitleChatCompletionResponseSchema.extend({
    threadId: z.string(),
  });

export type AiGetOnsiteEditTitleResponseBodyType = z.infer<
  typeof AiGetOnsiteEditTitleResponseBodySchema
>;
